import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import moment from "moment";

export const handleDayGlanceExcel = async (
  filteredData = [],
  saleReturnData = [],
  purchaseData = [],
  purchaseReturnData = [],
  supplierData = [],
  receiptData = [],
  bankData = [],
  journalReceiptData = [],
  journalPaymentData = [],
) => {
  const workbook = new ExcelJS.Workbook();
  workbook.creator = "Day Glance Report";
  workbook.created = new Date();

  const createSheet = (title, data) => {
    if (!Array.isArray(data) || data.length === 0) return;

    const sheet = workbook.addWorksheet(title);

    sheet.columns = [
      { header: "INV NO", key: "billno", width: 12 },
      { header: "DATE", key: "date", width: 12 },
      { header: "CUSTOMER", key: "customer", width: 25 },
      { header: "QTY", key: "qty", width: 8 },
      { header: "TOT AMT", key: "totamt", width: 12 },
      { header: "DISCOUNT", key: "discount", width: 12 },
      { header: "NET AMT", key: "netamt", width: 12 },
      { header: "CASH", key: "cash", width: 12 },
      { header: "CARD", key: "card", width: 12 },
      { header: "UPI", key: "upi", width: 12 },
      { header: "ONLINE", key: "online", width: 12 },
      { header: "BALANCE", key: "balance", width: 12 },
      { header: "CHEQUE", key: "cheque", width: 12 },
    ];

    // Header style
    sheet.getRow(1).eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: "center" };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFD4D2D2" },
      };
      cell.border = {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      };
    });

    let totals = {
      qty: 0,
      totamt: 0,
      discount: 0,
      netamt: 0,
      cash: 0,
      card: 0,
      upi: 0,
      online: 0,
      balance: 0,
      cheque: 0,
    };

    data.forEach((item) => {
      sheet.addRow({
        billno: item.billno || "",
        date: moment(item.BillDate).format("DD/MM/YYYY"),
        customer: item.CustName || "",
        qty: item.totqty || 0,
        totamt: item.totamt || 0,
        discount: item.discount || 0,
        netamt: item.NETAMT || 0,
        cash: item.PAIDCASH || 0,
        card: item.PAIDCARD || 0,
        upi: item.PAIDUPI || 0,
        online: item.PAIDONLINE || 0,
        balance: item.BALANCE || 0,
        cheque: item.PAIDCHEQUE || 0,
      });

      totals.qty += Number(item.totqty || 0);
      totals.totamt += Number(item.totamt || 0);
      totals.discount += Number(item.discount || 0);
      totals.netamt += Number(item.NETAMT || 0);
      totals.cash += Number(item.PAIDCASH || 0);
      totals.card += Number(item.PAIDCARD || 0);
      totals.upi += Number(item.PAIDUPI || 0);
      totals.online += Number(item.PAIDONLINE || 0);
      totals.balance += Number(item.BALANCE || 0);
      totals.cheque += Number(item.PAIDCHEQUE || 0);
    });

    // Totals row
    const totalRow = sheet.addRow({
      billno: "TOTAL",
      qty: totals.qty,
      totamt: totals.totamt,
      discount: totals.discount,
      netamt: totals.netamt,
      cash: totals.cash,
      card: totals.card,
      upi: totals.upi,
      online: totals.online,
      balance: totals.balance,
      cheque: totals.cheque,
    });

    totalRow.eachCell((cell) => {
      cell.font = { bold: true };
      cell.border = {
        top: { style: "double" },
        bottom: { style: "double" },
      };
    });

    // Number formatting
    sheet.eachRow((row, rowNumber) => {
      if (rowNumber > 1) {
        row.eachCell((cell, colNumber) => {
          if (colNumber >= 4) {
            cell.numFmt = "#,##0.00";
          }
        });
      }
    });
  };

  createSheet("SALE", filteredData);
  createSheet("SALE RETURN", saleReturnData);
  createSheet("PURCHASE", purchaseData);
  createSheet("PURCHASE RETURN", purchaseReturnData);
  createSheet("SUPPLIER PAYMENT", supplierData);
  createSheet("RECEIPT", receiptData);
  createSheet("BANK ENTRYS", bankData);
  createSheet("JOURNAL RECEIPT", journalReceiptData);
  createSheet("JOURNAL PAYMENT", journalPaymentData);

  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(
    new Blob([buffer]),
    `Day_Glance_Report_${moment().format("DD-MM-YYYY")}.xlsx`,
  );
};
